import Header from "../components/Header";
import ForgotPassword from "../components/ForgotPassword";
import Footer from "../components/Footer";

import "./styles.css"

export default function ContactUs() {
    return (
        <div className="CreateAccount">
            <Header></Header>
            <ForgotPassword></ForgotPassword>
            <Footer></Footer>
        </div>
    );
}
